import { createIcon } from '@chakra-ui/icons';

export const CircleLock = createIcon({
  displayName: 'CircleLock',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.40918C7.4828 0.40918 8.90463 0.998376 9.95312 2.04688C11.0016 3.09537 11.5908 4.5172 11.5908 6C11.5908 7.4828 11.0016 8.90463 9.95312 9.95312C8.90463 11.0016 7.4828 11.5908 6 11.5908C4.5172 11.5908 3.09537 11.0016 2.04688 9.95312C0.998376 8.90463 0.40918 7.4828 0.40918 6C0.40918 4.5172 0.998376 3.09537 2.04688 2.04688C3.09537 0.998376 4.5172 0.40918 6 0.40918Z"
        stroke="currentColor"
        strokeWidth="0.818182"
      />
      <path
        d="M5.53294 4.59995C5.53294 4.47618 5.58211 4.35749 5.66963 4.26997C5.75714 4.18245 5.87584 4.13328 5.99961 4.13328C6.12338 4.13328 6.24208 4.18245 6.32959 4.26997C6.41711 4.35749 6.46628 4.47618 6.46628 4.59995V5.53328H7.39961V4.59995C7.39961 4.22865 7.25211 3.87255 6.98956 3.61C6.72701 3.34745 6.37091 3.19995 5.99961 3.19995C5.62831 3.19995 5.27221 3.34745 5.00966 3.61C4.74711 3.87255 4.59961 4.22865 4.59961 4.59995V5.53328H5.53294V4.59995Z"
        fill="currentColor"
      />
      <path
        d="M7.86602 6H4.13268C3.87495 6 3.66602 6.20893 3.66602 6.46667V8.33333C3.66602 8.59107 3.87495 8.8 4.13268 8.8H7.86602C8.12375 8.8 8.33268 8.59107 8.33268 8.33333V6.46667C8.33268 6.20893 8.12375 6 7.86602 6Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
